import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import GroupShopTableGroup from '../organisms/GroupShopTableGroup';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getShops } from '../../actions/Shop';
import { getGroupDetail } from '../../actions/Groups';
import { getAccounts } from '../../actions/Accounts';
import ShopAddGroup from '../organisms/ShopAddGroup';
import MenuDrawerGroup from '../../components/MenuDrawerGroup';

const styles = theme => ({
  root: {
    // backgroundColor: '#e0e0e0',
    // flexGrow: 1,
    // width: '100%'
    display: 'flex'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: 'calc(100% - 240px)'
  },
  title: {
    color: '#000',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 15
  },
  pageTitileDiv: {
    padding: 0
  },
  pageTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    paddingRight: 45
  },
  mainPaper: {
    position: 'relative',
    margin: '20px 0'
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '26px 26px 26px 26px'
  },
  formFlex: {
    display: 'flex',
    alignItems: 'flex-end'
  },
  buttonSearch: {
    margin: '5px 5px',
    fontWeight: 'bold',
    paddingTop: 10
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textField200: {
    padding: '0px 0px 5px 0px',
    width: '200px'
  },
  button: {
    margin: '5px 0 5px 5px'
  },
  buttonLeft: {
    textAlign: 'left'
    // CSV出力ボタンを実装時にコメントアウトを外す
    // float: 'left'
  },
  buttonGroupLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  buttonGroupRight: {
    textAlign: 'right'
  },
  tableTopDiv: {
    display: 'flex',
    textAlign: 'right',
    // paddingBottom: '20px',
    alignItems: 'flex-start'
  },
  flexRight: {
    marginLeft: 'auto'
  },
  bottomButtonDiv: {
    padding: '10px 26px 10px 0px',
    textAlign: 'right'
  },
  formControl: {
    paddingLeft: 5,
    paddingRight: 5,
    width: 'auto'
  },
  subTitle: {
    fontWeight: '600',
    fontSize: 12,
    marginBottom: 10,
    color: '#000000'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      shops: state.shops.shops,
      totalCount: state.shops.totalCount,
      limit: state.shops.limit,
      groupDetail: state.groups.detail
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getShops, getGroupDetail, getAccounts },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openModal', 'updateOpenModal', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openShopAdd', 'updateOpenShopAdd', false),
  withState('openShopAddConfirm', 'updateOpenShopAddConfirm', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('groupId', 'setGroupId', ''),
  withState('shopName', 'setShopName', null),
  withState('unnarrowDownGroup', 'setUnnarrowDownGroup', true),
  withState('groupName', 'setGroupName', ''),
  withState('cityId', 'setCityId', ''),
  withState('address', 'setAddress', null),
  withState('depositManage', 'setDepositManage', ''),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 10),
  withState('paymentGroupType', 'setPaymentGroupType', ''),
  withState('filterParams', 'setFilterParams', {}),
  withState('hideRowsPerPage', 'setHideRowsPerPage', true),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangeRowsPerPage: props => event => {
      props.setRowsPerPage(event.target.value);
    },
    handleChangePage: props => async (event, page, limit, filterParams) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 10;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }

      const searchKey = {
        groupId: props.groupId,
        // shopName: props.shopName,
        // address: props.address,
        unnarrowDownGroup: props.unnarrowDownGroup,
        page,
        limit: limit || limitNum,
        ...filterParams
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      await props.actions
        .getShops(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          props.updateOpenProgress(false);
          props.updateLoading(false);
          props.updateOpenTable(true);
        })
        .catch(() => {
          props.updateOpenProgress(false);
          props.updateLoading(false);
        });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.updateOpenProgress(true);
      this.props.updateLoading(true);
      this.props.actions
        .getAccounts({ cognitoUserId: '' })
        .then(data => this.props.checkSession(data));
      this.props.setGroupId(this.props.groupDetail.groupId);
      this.props.setGroupName(this.props.groupDetail.groupName);
      this.props.setDepositManage(this.props.groupDetail.depositManage);
      this.props.setPaymentGroupType(this.props.groupDetail.paymentGroupType);
      this.props.actions
        .getShops({
          groupId: this.props.account.groupId,
          unnarrowDownGroup: this.props.account.groupId
            ? this.props.unnarrowDownGroup
            : false,
          shopName: this.props.shopName,
          address: this.props.address,
          page: this.props.page,
          limit: this.props.rowsPerPage
        })
        .then(shopData => {
          this.props.checkSession(shopData);
          if (shopData.type === 'GET_SHOPS_SUCCESS') {
            this.props.updateOpenTable(true);
          }
          this.props.updateOpenProgress(false);
          this.props.updateLoading(false);
        });
    }
  })
);

const Main = enhance(
  ({
    classes,
    account,
    handleChangePage, // updateOpenDrawer, // handleRedirect, // openDrawer,
    handleChangeRowsPerPage,
    openTable,
    updateOpenTable,
    openShopAdd,
    updateOpenShopAdd,
    openShopAddConfirm,
    updateOpenShopAddConfirm,
    loading,
    openProgress,
    groupId,
    shopName,
    setShopName,
    cityId,
    setCityId,
    address,
    setAddress,
    unnarrowDownGroup,
    groupName,
    depositManage,
    paymentGroupType,
    page,
    totalCount,
    limit,
    setFilterParams,
    setRowsPerPage,
    hideRowsPerPage,
    filterParams
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const roles = {
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 10;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchKey = {
      groupId,
      shopName,
      address,
      unnarrowDownGroup,
      page,
      limit: limitNum
    };
    const groupShop = true;

    const searchAction = async () => {
      updateOpenTable(true);
      const newFilterParams = {
        shopName: shopName || undefined,
        address: address || undefined
      };
      setFilterParams(newFilterParams);
      handleChangePage(null, 1, limitNum, newFilterParams);
    };
    const registerOpenAction = () => updateOpenShopAdd(true);
    const shopCancelAction = () => updateOpenShopAdd(false);
    const shopBackAction = () => updateOpenShopAddConfirm(false);
    console.log(paymentGroupType);

    return (
      <div className={classes.root}>
        <MenuDrawerGroup title="グループ店舗管理" />
        <main className={classes.content}>
          <Typography variant="h6" noWrap className={classes.title}>
            グループ店舗管理
          </Typography>
          <div className={classes.pageTitileDiv}>
            <Typography color="textPrimary" className={classes.pageTitle}>
              {groupName}
            </Typography>
          </div>
          <Paper className={classes.mainPaper} elevation={1}>
            <div className={classes.searchForm}>
              <div className={classes.formFlex}>
                <FormControl
                  className={clsx(classes.margin, classes.formControl)}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>店舗名</FormLabel>
                  <TextField
                    placeholder="例) Gigi 〇〇店"
                    type="search"
                    className={classes.textField200}
                    variant="outlined"
                    size="small"
                    value={shopName}
                    onChange={e => {
                      setShopName(e.target.value);
                    }}
                  />
                </FormControl>
                <FormControl
                  className={clsx(classes.margin, classes.formControl)}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>住所</FormLabel>
                  <TextField
                    placeholder="例) 東京都 渋谷区 0-0-0"
                    type="search"
                    className={classes.textField200}
                    variant="outlined"
                    size="small"
                    value={address}
                    onChange={e => {
                      setAddress(e.target.value);
                    }}
                  />
                </FormControl>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.buttonSearch}
                  onClick={searchAction}
                >
                  検索
                </Button>
              </div>
            </div>
          </Paper>
          <div className={classes.tableTopDiv}>
            <ExPaginationGroup
              count={
                totalCount % limit > 0
                  ? Math.floor(totalCount / limit) + 1
                  : Math.floor(totalCount / limit)
              }
              selectedPage={page}
              handleChangePage={(e, p, l) =>
                handleChangePage(e, p, l, filterParams)
              }
              limit={limit}
              setLimit={setRowsPerPage}
              totalCount={totalCount}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              hideRowsPerPage={hideRowsPerPage}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={registerOpenAction}
              className={[classes.button, classes.flexRight]}
            >
              グループ店舗追加
            </Button>
          </div>
          {openTable && (
            <Paper variant="outlined" square>
              <GroupShopTableGroup
                roles={roles}
                searchKey={searchKey}
                page={page}
                handleChangePage={(e, p, l) =>
                  handleChangePage(e, p, l, filterParams)
                }
                selectedPage={page}
              />
            </Paper>
          )}
          <div className={classes.bottomButtonDiv}>
            <ExPaginationGroup
              count={
                totalCount % limit > 0
                  ? Math.floor(totalCount / limit) + 1
                  : Math.floor(totalCount / limit)
              }
              selectedPage={page}
              handleChangePage={(e, p, l) =>
                handleChangePage(e, p, l, filterParams)
              }
              limit={limit}
              setLimit={setRowsPerPage}
              totalCount={totalCount}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              hideRowsPerPage={hideRowsPerPage}
            />
          </div>
          <div>
            <Modal open={openShopAdd}>
              <ShopAddGroup
                openShopAddConfirm={openShopAddConfirm}
                updateOpenShopAdd={updateOpenShopAdd}
                updateOpenShopAddConfirm={updateOpenShopAddConfirm}
                groupDepositManage={depositManage}
                paymentGroupType={paymentGroupType}
                cancelAction={shopCancelAction}
                backAction={shopBackAction}
                searchKey={searchKey}
                groupShop={groupShop}
                roles={roles}
                cityId={cityId}
                setCityId={setCityId}
              />
            </Modal>
          </div>
        </main>

        <ProgressDialog openProgress={openProgress} loading={loading} />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
